import request from '../utils/http'
// 用户列表
export function index (query) {
  return request({
    url: '/user/list',
    method: 'GET',
    params: query
  })
}
// 新增用户
export function save (query) {
  return request({
    url: '/user/save',
    method: 'POST',
    data: query
  })
}
// 编辑用户
export function edit (query) {
  return request({
    url: '/user/edit',
    method: 'GET',
    params: query
  })
}
// 查看用户续费记录
export function subscriptionLog (query) {
  return request({
    url: '/coupon/api/subscriptionLog?page=1&size=500',
    method: 'GET',
    headers: {
      'Custom-Params': 'javaApi'
    },
    params: query
  })
}
// 更新用户
export function update (query) {
  return request({
    url: '/user/update',
    method: 'POST',
    data: query
  })
}
// 删除用户
export function del (query) {
  return request({
    url: '/user/delete',
    method: 'DELETE',
    data: query
  })
}
// 用户开关
export function show (query) {
  return request({
    url: '/user/show',
    method: 'POST',
    data: query
  })
}
// 导出会员数据
export function userExport (query) {
  return request({
    url: '/user/export',
    method: 'POST',
    responseType: 'blob',
    data: query
  })
}
// APP作业开关
export function teacher (query) {
  return request({
    url: '/user/teacher',
    method: 'POST',
    data: query
  })
}
// PC出题开关
export function topic (query) {
  return request({
    url: '/user/topic',
    method: 'POST',
    data: query
  })
}
// PC课堂开关
export function classroom (query) {
  return request({
    url: '/user/classroom',
    method: 'POST',
    data: query
  })
}
// 学生作业开关
export function student (query) {
  return request({
    url: '/user/student',
    method: 'POST',
    data: query
  })
}
// 续费
export function renew (query) {
  return request({
    url: '/user/renew',
    method: 'POST',
    data: query
  })
}
// 校区列表
export function campusList (query) {
  return request({
    url: '/campus/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 机构列表
export function mechanismList (query) {
  return request({
    url: '/mechanism/list?limit=500',
    method: 'GET',
    params: query
  })
}
// 班级列表
export function classesList (query) {
  return request({
    url: '/classes/list?limit=500',
    method: 'GET',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/member.js